import { SWRConfig } from "swr"
import { useCurrentUser } from "web/hooks/data"

import { LocalizationContext, ModalsProvider } from "web/contexts"

export function AppProviders({ children }) {
  const currentUser = useCurrentUser()
  const localizationData = {
    viewCurrency: currentUser.default_currency,
    viewAreaUnit: currentUser.default_area_unit,
    viewLengthUnit: currentUser.default_length_unit,
    viewDistanceUnit: currentUser.default_distance_unit,
    defaultCurrency: currentUser.default_currency,
    defaultAreaUnit: currentUser.default_area_unit,
    defaultLengthUnit: currentUser.default_length_unit,
    defaultDistanceUnit: currentUser.default_distance_unit,
  }

  return (
    <LocalizationContext.Provider value={localizationData}>
      <ModalsProvider>{children}</ModalsProvider>
    </LocalizationContext.Provider>
  )
}

export function LibraryProviders({ children }) {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
      }}
    >
      {children}
    </SWRConfig>
  )
}
